export default function Marquee({ items, dark = true }) {
  const row = items.map((i) => `${i} \u2014`).join(" ") + " ";
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 ${
        dark ? "bg-ink text-paper border-ink" : "bg-paper text-ink border-ink/10"
      }`}
    >
      <div className="flex w-max whitespace-nowrap animate-marquee">
        {[0, 1].map((i) => (
          <span
            key={i}
            aria-hidden={i === 1}
            className="font-display text-xl md:text-3xl uppercase tracking-tight pr-4"
          >
            {row.repeat(4)}
          </span>
        ))}
      </div>
    </div>
  );
}
